import { useTranslation } from "react-i18next";
import type { JsonObject } from "../../api/http/jsonDecoding";
import ItemReferenceName from "./ItemReferenceName";
import { itemKindOf } from "./itemKindOf";

/** "Kind of" and the more general item by name, linked at the pinned version (processes.md
 * P-19). An item that is a kind of none shows nothing. */
export default function KindOfLine({ definition }: { definition: JsonObject | null }) {
  const { t } = useTranslation();
  const general = itemKindOf(definition);
  if (general === null) {
    return null;
  }
  return (
    <p className="app-text-muted flex flex-wrap items-center gap-1 text-xs" data-kind-of={general}>
      {t("authoring.item.kindOf")}
      <ItemReferenceName reference={general} />
    </p>
  );
}
